import { ChangeEvent, FC, ReactNode, MouseEvent } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ControlPoint, Padding } from '@mui/icons-material';
import { ClearButton, Container, SearchContainer, TitleContainer } from '../Registration.styles';
import { Button, Input, Section } from '../../../components';
import { RegistrationPageDetails } from '../../../utils';
import { Autocomplete, Grid, TextField, createFilterOptions } from '@mui/material';
import ClearSharpIcon from '@mui/icons-material/ClearSharp';

interface RegistrationPageProps {
	entity: RegistrationPageDetails;
	children: ReactNode;
	searchTerm: string;
	disableNewButton?: boolean;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	onClear?: (event: MouseEvent<HTMLButtonElement>) => void;
	handleFilterEstado?: (estado: string) => void;
	filteredItems?:any[]
}

interface EstadoProps {
    nome: string;
	sigla: string;
}

const RegistrationPage: FC<RegistrationPageProps> = ({
	entity,
	searchTerm,
	children,
	disableNewButton = false,
	onChange,
	onClear,
	handleFilterEstado,
	filteredItems
}) => {
	const location = useLocation();
	const basePath = location.pathname.split('/').slice(0, 3).join('/');


	const estadosBrasil:EstadoProps[]  = [
		{ nome: "Acre", sigla: "AC" },
		{ nome: "Alagoas", sigla: "AL" },
		{ nome: "Amapá", sigla: "AP" },
		{ nome: "Amazonas", sigla: "AM" },
		{ nome: "Bahia", sigla: "BA" },
		{ nome: "Ceará", sigla: "CE" },
		{ nome: "Distrito Federal", sigla: "DF" },
		{ nome: "Espírito Santo", sigla: "ES" },
		{ nome: "Goiás", sigla: "GO" },
		{ nome: "Maranhão", sigla: "MA" },
		{ nome: "Mato Grosso", sigla: "MT" },
		{ nome: "Mato Grosso do Sul", sigla: "MS" },
		{ nome: "Minas Gerais", sigla: "MG" },
		{ nome: "Pará", sigla: "PA" },
		{ nome: "Paraíba", sigla: "PB" },
		{ nome: "Paraná", sigla: "PR" },
		{ nome: "Pernambuco", sigla: "PE" },
		{ nome: "Piauí", sigla: "PI" },
		{ nome: "Rio de Janeiro", sigla: "RJ" },
		{ nome: "Rio Grande do Norte", sigla: "RN" },
		{ nome: "Rio Grande do Sul", sigla: "RS" },
		{ nome: "Rondônia", sigla: "RO" },
		{ nome: "Roraima", sigla: "RR" },
		{ nome: "Santa Catarina", sigla: "SC" },
		{ nome: "São Paulo", sigla: "SP" },
		{ nome: "Sergipe", sigla: "SE" },
		{ nome: "Tocantins", sigla: "TO" }
	  ];

	  const filterOptions = createFilterOptions({
		matchFrom: 'start',
		stringify: (option: EstadoProps) => option.nome,
	  });
	  
	  


	return (
		<Container>
			<Section>
			    {entity.title === 'Concessionarias' ? (
				<h1 style={{padding:"15px 0px", position:"relative", bottom:"10px"}}>{entity.title} {`(${filteredItems?.length})`}</h1>
				):null}
				<TitleContainer>
					{entity.title !== 'Concessionarias' ? (
					<h1>{entity.title}</h1>
					):null}
					{entity.title === 'Concessionarias' ? (
						<Autocomplete
						id='option-estado-filter'
						options={estadosBrasil}
						getOptionLabel={(option) => option.nome}
						filterOptions={filterOptions}
						onChange={(event, value) => handleFilterEstado?.(value ? value.sigla : '')}
						sx={{ width: 180 }}

						renderInput={(params) => <TextField 
							sx={{
								padding: 0,
								maxHeight: 100,
								'& .MuiOutlinedInput-root': {
								  
								  '&:hover fieldset': {
									border: '1px solid #ced4da', 
								  },
								  '&.Mui-focused fieldset': {
									border: '1px solid  #FF6600', 
								  },
								},
							  }}
							  {...params}  {...params}  placeholder='Filtrar por Estado' 
							  />}
							  
					  />
						):null}

					<SearchContainer>
						<Input variant='search' value={searchTerm} onChange={onChange} />
						{onClear && (
							<ClearButton onClick={onClear}><ClearSharpIcon style={{width:"21px", height:"21px"}} /></ClearButton>
						)}

						

					</SearchContainer>
					
					{disableNewButton === false && (
						<Link to={`${basePath}/novo`}>
							<Button variant='large' fitContent>
								<ControlPoint fontSize='inherit' />
								<span>{entity.new}</span>
								<span className='desktop-title'>{entity.name}</span>
								
							</Button>
						</Link>
					)}
					
					

				</TitleContainer>
				{children}
			</Section>
		</Container>
	);
};

export default RegistrationPage;
